var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"tab-header-item",class:{ 'tab-header-item-active': _vm.active }},[_vm._t("default",function(){return [(_vm.icon)?_c('Icon',{attrs:{"name":_vm.icon}}):_vm._e(),_vm._v(" "+_vm._s(_vm.label)+" ")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }